import { useQuery } from '@tanstack/react-query';
import { API } from '~/shared/API/api';
import { LngLat } from 'ymaps3';

export const useGetParking = () => {
  const { data, isLoading, refetch, isSuccess } = useQuery({
    queryKey: ['parking'],
    queryFn: () => API.getParking(),
    retry: 1,
    select: (data) => data.data,
  });

  const parkingList =
    data?.payload.items.map((el) => ({
      id: el.id,
      count: el.free_spaces,
      coordinates: [el.lon, el.lat] as LngLat,
    })) || [];

  return { parkingList, data, isLoading, refetch, isSuccess };
};
